"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getEwsRequestDateString_1 = require("owa-mail-store/lib/services/utils/getEwsRequestDateString");
var getServiceContextFolderId_1 = require("owa-mail-store/lib/services/utils/getServiceContextFolderId");
var applyConversationActionRequest_1 = require("owa-service/lib/factory/applyConversationActionRequest");
var conversationAction_1 = require("owa-service/lib/factory/conversationAction");
var itemId_1 = require("owa-service/lib/factory/itemId");
var applyConversationActionOperation_1 = require("owa-service/lib/operation/applyConversationActionOperation");
var Utils_1 = require("owa-service/lib/Utils");
/**
 * Create the restore conversation action used in request body
 * @param conversationContext the conversation context to be restored
 * @param folderId the folder id
 * @return the restore conversation action used in request body
 */
function createConversationAction(conversationContext, folderId) {
    return conversationAction_1.default({
        Action: 'Restore',
        ConversationId: itemId_1.default({ Id: conversationContext.conversationId }),
        ContextFolderId: getServiceContextFolderId_1.default(folderId),
        ConversationLastSyncTime: getEwsRequestDateString_1.default(conversationContext.conversationLastSyncTimeStamp),
    });
}
/**
 * Configure the request body
 * @param conversationContexts the conversation contexts to be deleted
 * @param folderId the folder id
 * @return the applyConversationActionRequest body
 */
function configureRequestBody(conversationContexts, folderId) {
    var conversationActions = conversationContexts.map(function (conversationContext) {
        return createConversationAction(conversationContext, folderId);
    });
    return applyConversationActionRequest_1.default({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: false,
    });
}
/**
 * Restore message service
 * @param conversationContexts the conversation contexts to be deleted
 * @param folderId the folder id
 * @return the ApplyConversationActionResponseMessage
 */
function restoreConversationService(conversationContexts, folderId) {
    var requestBody = configureRequestBody(conversationContexts, folderId);
    return applyConversationActionOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = restoreConversationService;
//# sourceMappingURL=restoreConversationService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/services/restoreConversationService.js
// module id = 3814
// module chunks = 62